import { useMemo } from 'react';
import { Divider } from '@mui/material';

import { HeadingFormField } from 'types';
import { QuestionLabel } from 'components/question-label';
import { defaultLanguage, useTranslationContext } from 'context';

export const FormHeading = ({
  label,
  subtitle,
  translations,
}: HeadingFormField) => {
  const { language } = useTranslationContext();
  const content = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return { subtitle, title: label };
    }

    const translation = translations[language];
    return {
      title: translation?.label || label,
      subtitle: translation?.subtitle || subtitle,
    };
  }, [label, subtitle, language, translations]);

  return (
    <section className="col-span-full w-full pt-2">
      <div role="heading" aria-level={2} className="text-xl font-semibold">
        <QuestionLabel value={content.title} />
      </div>
      {content.subtitle?.trim() && (
        <p className="text-black-primary mt-1 text-base">{content.subtitle}</p>
      )}
      <Divider sx={{ my: 2 }} />
    </section>
  );
};
